import * as React from 'react'
import {Pool} from './idqsa'
import {useTrackReadSignal} from './useTrackReadSignal'

export function useTrackReadSignalRef(pool?: Pool, resultItemId?: string | null) {
  const containerRef = React.useRef<HTMLDivElement>(null)
  useTrackReadSignal(() => containerRef.current, pool, resultItemId)
  return containerRef
}
